/* eslint-disable */
/* tslint disable */

/**
 * {
    i: StoryHourImg,
    n: `Family Craft Time With Erica Grady`,
    d: `Second Saturday July - August`,
    de: `<p class="title">Family Craft Time</p>
    <p>Second Saturday of June-August 11:00am—12:00pm</p><img style="display: block;max-width: 300px;" src=${StoryHourImg} /><p>All ages are welcome. No registration required.</p>
    Berkley Public Library presents a family-friendly outdoor Craft Time at Dighton Rock State Park focused on the history of Dighton Rock including stories, music, and activities.</p><p> Presented by Erica Grady, Berkley Library Children’s Librarian. 
    Program will take place outdoors. Consider sunscreen, drinking water, and bug spray. Bring a blanket or lawn chair. During inclement weather, we will move into the Museum.</p><p>Program sponsored by the Berkley Public Library, the Friends of the Dighton Rock Museum, and the Massachusetts Department of Conservation & Recreation.</p>
    `,
  },
 */

import React, { useEffect } from "react";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InnerHTML from "dangerously-set-html-content";
import styled from "@emotion/styled";
import GD from "../images/gd.png";
// import StoryHourImg from "../images/storyhour.png";
import Yoga from "../images/yoga.png";
import { AddToCalendarButton } from "add-to-calendar-button-react";

const Text = styled(Typography)`
  p:first-child {
    font-weight: bold;
  }
`;

const getIsMobile = () =>
  Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth,
  ) < 900;

const events = [
  {
    n: `CAPRON PARK ZOOMOBILE`,
    cd: `2026-04-12`,
    d: `April 12, 2026`,
    st: `13:00`,
    et: `15:00`,
    de: `<p>1pm - 3:00pm</p><p>Caitlynn Newton, Zoo Education Curator, 
    will present Zoomobile Animal Encounters. Join us at 1:00, 1:45, or 2:30 p.m. 
    For all ages. Supported in part by a grant from the Berkley Cultural Council, 
    which is supported by the Mass. Cultural Council, a state agency.</p>`,
  },
  {
    n: `PARK SERVE DAY`,
    cd: `2026-05-02`,
    d: `May 2, 2026`,
    st: `13:00`,
    et: `15:00`,
    de: `<p>1pm - 3pm</p><p>Join the Friends of the Dighton Rock Museum and DCR staff 
    to beautify the park on this day of service. Help pick up trash and restore this 
    amazing natural space. All necesary materials - gloves, trash bags, etc - will be 
    provided. For all ages.</p>`,
  },
  {
    n: `MAKE YOUR OWN FAIRY GARDEN PLANTERS`,
    cd: `2026-05-03`,
    d: `May 03, 2026`,
    st: `13:00`,
    et: `15:30`,
    de: `<p>1pm - 2:30pm</p><p>Sue McKay will provide instruction, lots of supplies and enthusiasm as she guides you to work with
    natural materials to design and make a fairy garden planter for each participant to bring home. For all ages. Supported in part by a grant
    from the Berkley Cultural Council, which is supported by the Mass. Cultural Council, a state agency.</p>`,
  },
  {
    n: `BIRDING TALK AND WALK`,
    cd: `2026-06-14`,
    d: `June 14, 2026`,
    st: `13:00`,
    et: `14:00`,
    de: `<p>1pm - 2pm</p><p>Lorie Van Hook will lead a bird walk at 1, along the way sahring info about bird 
    identification and bird watching. Lorie will bring binoculars and a scope for participants to use. 
    For all ages. Dress for the weather and bring binoculars if you have them.</p>`,
  },
  {
    n: `HISTORIC SHIPS, COLONIAL & POST-COLONIAL TIMES`,
    cd: `2026-07-12`,
    d: `July 12, 2026`,
    st: `13:00`,
    et: `14:00`,
    de: `<p>1pm - 2pm</p><p>A presentation by Alan Gianatassio about some of the historic ships built on the
    North River. Included will be the Beaver, one of the Boston Tea Party ships. Also included will be a brief 
    story of the Molasses Protest in Dighton in 1765, predating the Boston Tea Party. For ages 8+.</p>`,
  },
  {
    n: `WATER QUALITY MONITORING`,
    cd: `2026-08-09`,
    d: `August 9, 2026`,
    st: `13:00`,
    et: `15:00`,
    de: `<p>1pm - 3pm</p><p>Learn about water quality in the Taunton River Watershed. We'll be joined by a panel of local stakeholders
    who will explore how water quality is measured, and how to make sense of the data in engaging, easy to
    understand presentations. Visit interactive stations, each offering hands-on activities
    highlighting aspects of water quality monitoring. For all ages.</p>`,
  },
  {
    n: `CAPRON PARK ZOOMOBILE`,
    cd: `2026-09-13`,
    d: `September 13, 2026`,
    st: `13:00`,
    et: `15:00`,
    de: `<p>1pm - 3pm</p><p>A second visit with different animals to meet and learn about - presented by Caitlynn, the Zoo Curator
    at 1, 1:45, or 2:30pm. For all ages. Also supported in part by a grant from the Berkley Cultural Council, which is supported
    by the Mass. Cultural Council, a state agency.</p>`,
  },
  {
    n: `LOCAL HISTORY TALK`,
    cd: `2026-10-11`,
    d: `October 11, 2026`,
    st: `13:00`,
    et: `14:00`,
    de: `<p>1pm - 2pm</p><p>Berkley History Museum's Eden Waterfield Jones, Elwell Perry, and Michael Lucas will explore
    Berkley's history and share rarely-seen materials from the museum's behind-the-scenes collection. Prepare for a 
    lively discussion about our shared history. For ages 8+.</p>`,
  },
].sort((a, b) =>
  new Date(a.d) > new Date(b.d) || !new Date(b.d).valueOf() ? 1 : -1,
);

const SideWrap = styled.div`
  padding: 20px;
`;

const Spacer = styled.div`
  height: 30px;
  width: 100%;
`;

const InlineImg = styled.img`
  height: 100%;
`;

const SideContent = () => (
  <SideWrap>
    <a
      href="https://goo.gl/maps/KZL36qshZB9kFqgf8"
      rel="noreferrer"
      target="_blank"
    >
      <img
        style={{
          height: `55px`,
          margin: `0 20px 0 0`,
          verticalAlign: `middle`,
        }}
        alt="get directions"
        src={GD}
      />
      <span style={{ verticalAlign: `middle` }}>Get Directions</span>
    </a>
    <p>3rd Ave, Berkley, MA 02779</p>
    {["/", "/events"].includes(window.location.pathname) && (
      <InnerHTML
        html={`<a class="weatherwidget-io" href="https://forecast7.com/en/41d85n71d08/berkley/?unit=us" data-label_1="BERKLEY" data-label_2="WEATHER" data-theme="pure" >BERKLEY WEATHER</a>
<script>
!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src='https://weatherwidget.io/js/widget.min.js';fjs.parentNode.insertBefore(js,fjs);}}(document,'script','weatherwidget-io-js');
</script>`}
      />
    )}
  </SideWrap>
);

const formatDate = (d: string) =>
  new Date(d).toLocaleString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const Events = () => {
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(getIsMobile());

  let timer: ReturnType<typeof setTimeout>;

  const setTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(() => setIsMobile(getIsMobile()), 500);
  };

  useEffect(() => {
    setIsMobile(getIsMobile());
    window.addEventListener("resize", setTimer);
  }, []);

  useEffect(() => {
    // @ts-ignore
    let __weatherwidget_init: Function = window["__weatherwidget_init"];
    if (typeof __weatherwidget_init === "function") {
      //  eslint-disable-next-line
      __weatherwidget_init();
    }
  }, [window.location.pathname]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <>
      <div
        style={{
          display: `inline-block`,
          verticalAlign: `top`,
          width: isMobile ? `100%` : `calc(100% - 300px)`,
        }}
      >
        <Spacer />
        {events.map((fd, i) => (
          <Accordion
            key={fd.n}
            expanded={expanded === `panel${i}`}
            onChange={handleChange(`panel${i}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography
                sx={{
                  width: "10%",
                  minWidth: "90px",
                  height: `40px`,
                  flexShrink: 0,
                  marginRight: `10px`,
                  color: `#0277BD`,
                  fontWeight: `700`,
                }}
              ></Typography>
              <Typography
                sx={{
                  width: "33%",
                  height: `40px`,
                  flexShrink: 0,
                  marginRight: `10px`,
                  color: `#0277BD`,
                  fontWeight: `700`,
                }}
              >
                {new Date(fd.d).valueOf() ? formatDate(fd.d) : fd.d}
              </Typography>
              <Typography sx={{ color: `#0277BD`, fontWeight: `700` }}>
                {fd.n}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Text
                dangerouslySetInnerHTML={{ __html: fd.de }}
                sx={{ padding: `6px 8px` }}
              />

              {!!new Date(fd.d).valueOf() && (
                <AddToCalendarButton
                  name={fd.n}
                  options={["Apple", "Google", `Microsoft365`, `Outlook.com`]}
                  location="Dighton Rock Museum"
                  startDate={fd.cd}
                  endDate={fd.cd}
                  startTime={fd.st}
                  endTime={fd.et}
                  timeZone="America/New_York"
                ></AddToCalendarButton>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      <div
        style={{
          display: isMobile ? `block` : `inline-block`,
          minWidth: `300px`,
        }}
      >
        <SideContent />
      </div>
    </>
  );
};

export default Events;
